import _ from "lodash"
import { useDispatch } from "react-redux"
import { Text, TextField } from "@fluentui/react"
import { CREATE_CONTACT_KEY } from "../CreateContactDialog/CreateContactDialog"
import { getBpDetailsAction } from "../../actions"
import { useEffect, useState } from "react"
import { useAppBridgeSelector } from "@dladio/app-bridge"
import { localStoreThunk, useForm } from "@dladio/hooks"
import { AutoCompleteTextField, Stack } from "@dladio/core-ui"


const { setStore: setContactStore } = localStoreThunk(CREATE_CONTACT_KEY)

const AccountInformationForm = () => {

    const dispatch = useDispatch()
    const { form, formController, setForm } = useForm()
    const { setForm: setContactForm } = useForm(CREATE_CONTACT_KEY)

    const { model } = useAppBridgeSelector()

    console.log("_.get(model, 'params.id')",_.get(model, 'params.id'))
    console.log("model", model)
    //create contact
    const [visibleCreateContact, setVisibleCreateContact] = useState(false)
    const [typedContactName, setTypedContactName] = useState()    

    useEffect(() => {
        setForm('bpCode', _.get(model, 'params.id'))
    }, [_.get(model, 'params.id')])

    useEffect(() => {
        dispatch(getBpDetailsAction(_.get(form, 'bpCode')) as any)
    }, [_.get(form, 'bpCode')])

    return (
        <>
            <Stack className={"gap-2"}>
                <AutoCompleteTextField
                    keyValuePair={{ key: 'CardCode', text: 'CardName' }}
                    defaultKey={_.get(form, 'bpCode')}
                    label={"Account"}
                    required
                    id={'bpCode'}
                    onChange={formController}
                    options={{
                        type: "erp",
                        query: { name: '300895547c', id: '' }
                    }}
                />
                <div className="relative inline-block">
                    <AutoCompleteTextField
                        label={"Contact"}
                        required
                        id={'contact_person_code'}
                        onValueNotFound={(text: any) => {

                            if (text) {
                                setVisibleCreateContact(true)
                                setTypedContactName(text)
                                setContactForm("FirstName", text)
                                setTimeout(() => {
                                    document?.getElementById('create-contact-person')?.focus()
                                }, 100);
                            }
                        }}
                        onChange={formController}
                        options={{
                            type: "erp",
                            query: { name: 'f89b1145b2', id: _.get(form, 'bpCode') }
                        }}
                    />
                    {
                        visibleCreateContact ?
                            <div
                                onKeyDown={({ key }: any) => (key === 'Enter') && dispatch(setContactStore('isOpen', true) as any)}
                                onClick={() => dispatch(setContactStore('isOpen', true) as any)} id={'create-contact-person'}
                                tabIndex={0} onBlur={() => setVisibleCreateContact(false)}
                                className="origin-top-left px-2 absolute z-50 left-0 w-full max-h-[180px] shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none overflow-auto cursor-pointer">
                                <div className="flex flex-col">
                                    <Text className="font-bold" variant={'xSmall'}>Create Contact</Text>
                                    <Text variant={'xSmall'}>{typedContactName}</Text>
                                </div>
                            </div> : null
                    }
                </div>

                <TextField
                    required
                    name={"customer_ref_no"}
                    onChange={formController}
                    label={"Customer Ref.No"} />
            </Stack>
        </>
    )
}

export default AccountInformationForm